import React, { useEffect, useRef, useState } from "react";
import { InputItem, Toast, Modal } from 'antd-mobile';
import styled from 'styled-components';
import OutsiteBg from './imgs/outsite@2x.png';
import OutsiteFormBg from './imgs/outsite-form-bg@2x.png';
import OutsiteDesc from './imgs/outsite-desc@2x.png';
import OutsiteBtn from './imgs/outsite-btn@2x.png';
import { validPhone, rsaString } from '@/utils'
import { useParams } from 'react-router';
import { registerInvite } from './api';
import { sendMessage, getInvitationUserInfo } from '@/api/user-new'
import get from 'lodash/get';
import h5Share from '@/utils/h5Share';
import { RegistModalContent, CTitle} from '../integral_0803_20/share-pull-regist/style'

const InviteOutsite = () => {
  const [isSending, setIsSending] = useState(false);
  const [finishRegister, setFinishRegister] = useState(false);
  const [countDown, setCountDown] = useState(60);
  const countDownRef = useRef();
  countDownRef.current = countDown;

  const [phone, setPhone] = useState('')
  const [validCode, setValidCode] = useState('')
  const lastSeneTime = useRef(0);
  const timerRef = useRef();
  const { inviteCode } = useParams();

  const [userInfo, setUserInfo] = useState({});
  // const finishTimer = useRef(86400);
  // const finishCountDownRef = useRef();

  const loadingRef = useRef(false);

  const [visible, setvisible] = useState(false)

  useEffect(() => {
    fetchUserInfo();
  }, [])

  const fetchUserInfo = () => {
    getInvitationUserInfo({invitedCode: inviteCode}).then(res => {
      setUserInfo(res);

      h5Share.main({
        title: `你的好友${res.nickname}正在市值风云APP等你来`,
        desc: '这里是专业股民聚集地～集齐各种投资高手，各种投资策略全都有，就等你啦～',
        link: window.location.href,
        imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
        wxShare:{
          shareData:{
            imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
          }
        }
      })
    })
  }

  const startCountDown = () => {
    setCountDown(60);
    timerRef.current = setInterval(() => {
      console.log(countDownRef.current, 'countDownRef.current');
      if (countDownRef.current === 1) {
        setIsSending(false);
        clearInterval(timerRef.current);
        timerRef.current = null;
      } else {
        setCountDown(countDownRef.current - 1);
      }
    }, 1000);
  }

  const startFinishTimer = () => {
    // setInterval(() => {
    //   finishTimer.current -= 1;
    //   let restTime = finishTimer.current
    //   const hour = Math.floor(restTime / 3600);
    //   restTime = restTime - hour * 3600;
    //   const minute = Math.floor(restTime / 60)
    //   const second = restTime - minute * 60
    //   finishCountDownRef.current.innerHTML = `${hour}:${minute}:${second}`
    // }, 1000);
    
  }

  const handleSendCode = async () => {
    const now = new Date().valueOf();
    if (now - lastSeneTime.current < 1000) {
      return;
    }
    lastSeneTime.current = now;
    if (isSending) {
      return;
    }
    const phoneNum = phone.split(' ').join('');
    if (!validPhone(phoneNum)) {
      Toast.info('请输入正确手机号');
      return;
    }
    try {
      const res2 = await sendMessage({ PHONE: rsaString(phoneNum), type: '9' });
      if(res2.resultCode === '00'){
        setIsSending(true);
        startCountDown();
      } else {
        Toast.info(res2.resultMsg)
      }
    } catch (e) {

    }
  }
  const handleValidCodeChange = (e) => {
    if (e.target.value.length > 4) {
      return;
    }
    setValidCode(e.target.value);
  }

  const handleRegister = () => {
    if (loadingRef.current) {
      return;
    }
    const phoneNum = phone.split(' ').join('');
    if (!phoneNum || !validCode) {
      Toast.info('请输入手机号和验证码');
      return;
    }
    if (!validPhone(phoneNum)) {
      Toast.info('请输入正确手机号');
      return;
    }

    loadingRef.current = true;

    const params ={
      phone: phone.split(' ').join(''), 
      smsCode: validCode,
      inviteCode: inviteCode
    }
    registerInvite(params).then(res=>{
      loadingRef.current = false;
      if (res.errors) {
        Toast.info(res.errors[0].message)
        return
      }
      if (res.data === 'success') {
        setvisible(true);
        setFinishRegister(true);
        startFinishTimer();
      }
    }).catch(err => {
      loadingRef.current = false;
      const msg = get(err, 'response.data.errors[0].message')
      if (msg) {
        Toast.info(msg);
      }
    })
  }

  const handleLinkToApp = () => {
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }

  const openlink = () => {
    setvisible(false)
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }

  return <Container>
    <div className="user-box">
      <div className="avatar-wrap">
        <img className="user-avatar" alt="" src={userInfo.avatar} />
      </div>
      <div className="user-nickname">{userInfo.nickname}</div>
      <div className="send-text">邀请您一起使用市值风云APP炒股</div>
    </div>
    <div className="outsite-content">
      <div className="outsite-bg">
       {finishRegister ? 
       <div className="finish-form">
          <div className="finish-title">您已注册成功</div>
          <div className="finish-label">快和好友一起使用市值风云APP炒股吧</div>

          <div className="outsite-form">
            <div onClick={handleLinkToApp} className="take-immediately">前往市值风云APP</div>
          </div>
       </div>
        :
        <div className="outsite-form">
          <div className="input-item">
            <span>+86</span>
            <div className="input-split"></div>
            <InputItem
              type="phone"
              defaultValue={phone}
              editable
              clear
              onChange={(val)=> setPhone(val)}
              placeholder="请输入手机号码"
            />
          </div>
          <div className="input-item sms-code">
            <input value={validCode} onChange={handleValidCodeChange} type="number" className="number-input" placeholder="请输入验证码"/>
            <div className="count-down" onClick={()=>handleSendCode()}>{isSending ? `${countDown} 后重新获取` : "获取验证码"}</div>
          </div>
          <div onClick={handleRegister} className="take-immediately">立即领取</div>
          {/* <div className='take-desc'>领取成功后登录APP即刻享用VIP权益</div> */}
        </div>
        }
      </div>
    </div>
    <div className="outsite-desc"></div>
    <div className="outsite-explain">
      <div>活动一切解释权归市值风云所有</div>
      <div>投资有风险<span>入市需谨慎</span></div>
    </div>

    <Modal
      visible={visible}
      transparent
      className={'regist-modal'}
      maskClosable={true}
      onClose={()=> setvisible(false)}
      title=""
    >
      <RegistModalContent>
        <CTitle>
          <div className='back'></div>
          <div className='title'>恭喜</div>
        </CTitle>
        <div className={'regist-modal-content-text'}>
          <div>恭喜，您已经注册成功</div>
          <div>快前往市值风云APP使用吧</div>
        </div>
        <div className={'regist-modal-content-group'}>
          <div className={'regist-modal-content-button'} onClick={()=>openlink()}>打开APP</div>
        </div>
      </RegistModalContent>
    </Modal>
  </Container>
}

export default InviteOutsite;

const Container = styled.div`
  font-size: 0;
  background-image: url(${OutsiteBg});
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #f23f56;
  position: relative;

  .user-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 49px;
    .send-text {
      font-size: 17px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 17px;
      margin-top: 6px;
    }
    .send-value {
      font-size: 24px;
      line-height: 24px;
      color: #FF5400;
      font-weight: bold;
    }

    .avatar-wrap {
      width: 70px;
      height: 70px;
      border: 4px solid #fff;
      border-radius: 50%;
      .user-avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .user-nickname {
      height: 24px;
      padding: 0 22px;
      background: #FE7259;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      margin-top: 10px;
    }
  }

  .outsite-content {
    padding-top: 182px;
  }
  .outsite-bg {
    background-image: url(${OutsiteFormBg});
    background-size: 100% 100%;
    height: 516px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .outsite-form {
    padding: 0 57px 32px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    .input-split {
      width: 1px;
      height: 18px;
      background: #979797;
      margin: 0 9px;
    }
    .sms-code {
      justify-content: space-between;
      .number-input {
        width: 100px;
      }
    }
    .input-item {
      height: 50px;
      background: #FFFFFF;
      border: 1px solid #FD988A;
      border-radius: 25px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      .number-input {
        border: none;
        padding: 0;
        &::placeholder {
          font-size: 14px;
          font-weight: 500;
          color: #9696A6;
        }
      }
      .am-input-item {
        padding-left: 0;
      }
      .am-input-control input {
        font-size: 14px;
      }
    }
    .take-immediately {
      height: 54px;
      background-image: url(${OutsiteBtn});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .take-desc {
      font-size: 12px;
      line-height: 12px;
      font-weight: 400;
      color: #E0B6A4;
      margin-top: 12px;
      text-align: center;
    }
  }
  .finish-form {
    font-size: 14px;
    text-align: center;
    .finish-title {
      font-size: 18px;
      font-weight: bold;
      color: #353535;
      line-height: 18px;
      margin-bottom: 10px;
    }
    .finish-label {
      font-size: 14px;
      font-weight: 400;
      color: #353535;
      line-height: 14px;
      margin-bottom: 10px;
      margin-bottom: 46px;
    }
    .finish-countdown {
      margin-bottom: 20px;
      font-size: 43px;
      font-family: DIN;
      font-weight: bold;
      color: #E0B6A4;
      line-height: 43px;

      background: linear-gradient(262deg, #FF8241 0%, #FF454E 99.0478515625%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .outsite-desc {
    background-image: url(${OutsiteDesc});
    background-size: 100% 100%;
    height: 581px;
  }
  .outsite-explain {
    display: flex;
    align-items: center;
    padding: 28px 0 56px;
    flex-direction: column;
    font-size: 12px;
    font-weight: 400;
    color: #FF909E;
    line-height: 18px;
  }

`;


// WEBPACK FOOTER //
// ./src/views/activity_42/outsite.js